import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type OrganizationLogoFetchFailedAction = {
	type: 'ORGANIZATION_LOGO_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): OrganizationLogoFetchFailedAction => ({
	type: 'ORGANIZATION_LOGO_FETCH_FAILED',
	payload,
});
